import { create } from "zustand";

interface GalleryStoreState {
  isShow: boolean;
  onClose: () => void;
  showGallery : (images: GalleryImages[]) => void;
  images: GalleryImages[];
}

export interface GalleryImages {
  id: number,
  url: string,
}

export const useGalleryStore = create<GalleryStoreState>((set) => ({
  isShow: false,
  showGallery: (images: GalleryImages[]) => set(() => ({ isShow: true, images })),
  onClose: () => set(() => ({ isShow: false, images: [] })),
  images: []
}));
